import React, { useEffect, useMemo, useState } from "react";
import Spinner from "../../layouts/spinner/Spinner";
import { getReleaseData } from "../../apis/devopsApi/devopsApi";
import CreateNewReleaseModal from "../../components/CreateNewReleaseModal/CreateNewReleaseModal";
import axios from "axios";
import CreateFullReleaseModal from "../../components/CreateFullReleaseModal/CreateFullReleaseModal";

const Releases = () => {
  const [loading, setLoading] = useState(false);
  const [releaseDefinitions, setReleaseDefinitions] = useState<any>();
  const [releaseDefinitionNames, setReleaseDefinitionNames] = useState<any>();

  const columns = useMemo(
    () => [
      { header: "Name", key: "releaseDefinition.name" },
      { header: "Version", key: "name" },
      {
        header: "Artifact Version",
        key: "artifacts.0.definitionReference.version.name",
      },
      {
        header: "Build Version",
        key: "artifacts.0.definitionReference.version.id",
      },
      {
        header: "Triggered By",
        key: "createdBy.displayName",
      },
      { header: "Trigger Date", key: "createdOn" },
    ],
    []
  );

  useEffect(() => {
    setLoading(true);
    const abortController = new AbortController();
    const abort2 = new AbortController();

    getReleaseData(abortController.signal, (resp: any) => {
      if (resp) {
        console.log(resp);
        setReleaseDefinitions(resp.data);
      }
      setLoading(false);
    });

    getReleaseNames();
    async function getReleaseNames() {
      await axios
        .get(
          "https://p360zingadmin-t4-devenvapi.azurewebsites.net/api/releases/definitions",
          {
            signal: abort2.signal,
          }
        )
        .then(({ data }) => {
          setReleaseDefinitionNames(data.data);
        })
        .catch((err) => {
          console.error(err);
        });
    }

    return () => {
      abortController.abort();
      abort2.abort();
    };
  }, []);

  return (
    <div className="tab-page-layout-1">
      <div className="tab-page-layout-1-header">
        <div
          className="tab-page-layout-1-header-title-label"
          style={{
            flexDirection: "row",
            display: "flex",
            columnGap: "10rem",
            alignItems: "center",
            justifyContent: 'space-between',
          }}
        >
          <p style={{ margin: 0 }}>Releases</p>
          {/* <div
              className="add-btn-section header-icon"
              onClick={() => {
                setModaltitle("Add");
                setUpdateItemData(false)
                setUpdateModalFlag(false);
                setOpenAddItemModal(true)}}
            >
              <img src={addIcon} className="icon-md" alt=""/>
            </div> */}
          <div style={{display: 'flex', width: '100%'}}>
            <CreateNewReleaseModal
            />
            <CreateFullReleaseModal />
          </div>
        </div>
      </div>

      <div className="tab-page-layout-1-body">
        <div className="tab-page-layout-1-list-header config-list-header">
          {columns.map((col, index) => (
            <div className="tab-page-layout-1-li-item  font-bold" key={index}>
              {col.header}
            </div>
          ))}
        </div>

        <ul
          className="tab-page-layout-1-list-section config-list-section"
          id="client-list-section"
        >
          {loading ? (
            <div className="text-center">
              <Spinner />
            </div>
          ) : (
            <>
              {releaseDefinitions?.releases?.length > 0 &&
                releaseDefinitions?.releases.map((item: any, i: any) => {
                  return (
                    <li
                      className="tab-page-layout-1-list-item-section config-list-item-section"
                      key={i}
                    >
                      {columns.map((col, colindex) => {
                        const keys = col.key.split("."); // Split the key by '.'
                        let value = keys.reduce(
                          (obj, keyPart) => obj?.[keyPart],
                          item
                        ); // Access the nested property
                        if (keys.includes("createdOn")) {
                          value = new Date(value).toLocaleString("en-US", {
                            weekday: "long", // 'short', 'long', etc.
                            year: "numeric",
                            month: "long", // '2-digit', 'numeric'
                            day: "numeric",
                            hour: "2-digit", // 'numeric', '2-digit'
                            minute: "2-digit", // 'numeric', '2-digit'
                            second: "2-digit", // 'numeric', '2-digit'
                            hour12: true, // true for 12-hour clock, false for 24-hour clock
                          });
                        }
                        return (
                          <div
                            className="tab-page-layout-1-li-item"
                            title={value}
                            key={colindex}
                          >
                            {value}
                          </div>
                        );
                      })}
                      {/* <div
                        className="tab-page-layout-1-li-item"
                        title={item.name}
                      >
                        {item.name}
                      </div>
                      <div
                        className="tab-page-layout-1-li-item"
                        title={item.displayname}
                      >
                        {item.displayname}
                      </div>
                      <div
                        className="tab-page-layout-1-li-item"
                        title={item.Description}
                      >
                        {item.Description}
                      </div>
                      <div
                        className="tab-page-layout-1-li-item"
                        title={item.Active_Flg}
                      >
                        {item.Active_Flg}
                      </div>
                      <div
                        className="tab-page-layout-1-li-item"
                        title={item.Active_Flg}
                      >
                        {item.Key_Location}
                      </div> */}
                      <div className="tab-page-layout-1-li-item">
                        {/* <div onClick={()=>handleOpenUpdateModal(item)}>
                        <img src={editIcon} className="icon-wd-sm" alt=""/>
                      </div> */}
                      </div>
                    </li>
                  );
                })}
            </>
          )}
        </ul>

        {/* <div className="tab-page-layout-1-list-footer config-list-footer">
          <div className="row-count-section">
            <div className="row-count-label center-div">Show per page</div>
            <div className="row-count-dropdown-section center-div">
              <select
                name="filter-column"
                id=""
                className="column-dropdown row-count-dropdown  dropdown-arrow-1"
                onChange={(e) => setRowsPerPage(e.target.value)}
              >
                {rowCountRange.map((item: any, i) => (
                  <option value={item} key={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="page-number-section center-div">
            <div className="entries-count">
              {rowsPerPage * currentPage - rowsPerPage + 1} to{" "}
              {rowsPerPage * currentPage < configList.length
                ? rowsPerPage * currentPage
                : configList.length}{" "}
              of {configList.length} entries
            </div>
            <Pagination
              rowsPerPage={rowsPerPage}
              totalRows={configList.length}
              paginate={paginate}
              currentPage={currentPage}
            />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Releases;
